import { render } from "./Footer.vue?vue&type=template&id=bac451a8"
const script = {}

import exportComponent from "/Users/cb-it-01-1886/Documents/Chargbe Design/cb-payments-vue/cb-payments-dash/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__